import { createSlice } from '@reduxjs/toolkit';
import { deleteCookie, getCookie } from '../helpers/helper';

const initialState = {
  isAuthenticated: false, // The single source of truth for auth status
  workspaces: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthentication: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setWorkspaces: (state, action) => {
      state.workspaces = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
      state.error = action.payload.error || null;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.workspaces = [];
      deleteCookie('tempAuthToken');
      sessionStorage.removeItem('lastReoute')
      localStorage.removeItem('initialLocation')
      sessionStorage.removeItem('selectedWorkspace');

    },
    // This action checks localStorage on app load to see if we have a valid session.
    initializeAuth: (state) => {
      const token = getCookie('tempAuthToken');

      if (token ) {
        state.isAuthenticated = true;
      } else {
        state.isAuthenticated = false;
      }
    },
  },
});

export const { setAuthentication, setWorkspaces, setStatus, logout, initializeAuth } = authSlice.actions;

export default authSlice.reducer;
